/* eslint-disable no-console */
const isDebugDefaultValue = localStorage.getItem('cioDebug') === 'true';

type CIO_EVENT_NAME =
  | 'deposit_modal_open'
  | 'deposit_modal_close'
  | 'deposit_btn_click'
  | 'withdrawal_btn_click'
  | 'withdrawal_send_btn_click';

export const cio = ({
  isEnabled,
  debug = isDebugDefaultValue
}: {
  isEnabled: boolean;
  debug?: boolean;
}) => {
  const available = isEnabled && window.cioanalytics && Boolean(window.cioanalytics.identify);
  if (debug) {
    console.debug('[CIO available]:', {
      isEnabled,
      window: window.cioanalytics,
      identify: window.cioanalytics?.identify,
      available: available
    });
  }

  const cioIdentify = (identifyData: Record<string, unknown>) => {
    if (!available) return;
    try {
      window.cioanalytics.identify(identifyData);
      if (debug) {
        console.debug('[CIO identify]', identifyData);
      }
    } catch (error) {
      console.debug('[CIO identify error: handled]', error);
    }
  };

  const cioReset = () => {
    if (!available) return;
    try {
      window.cioanalytics.reset();
      if (debug) {
        console.debug('[CIO reset]');
      }
    } catch (error) {
      console.debug('[CIO reset error: handled]', error);
    }
  };

  const cioTrackEvent = (eventName: CIO_EVENT_NAME, clickPlace?: string) => {
    if (!available) return;
    try {
      switch (eventName) {
        case 'deposit_modal_open':
          window.cioanalytics.track(eventName, { url: window.location.href });
          break;
        case 'deposit_modal_close':
          window.cioanalytics.track(eventName);
          break;
        case 'deposit_btn_click':
        case 'withdrawal_btn_click':
        case 'withdrawal_send_btn_click':
          window.cioanalytics.track(eventName, {
            source: clickPlace,
            url: window.location.href
          });
          break;
        default:
          throw new Error('Invalid action');
      }

      if (debug) {
        console.debug('[CIO event]', eventName);
      }
    } catch (error) {
      console.debug('[CIO event error: handled]', error);
    }
  };

  const cioTrackPageChange = () => {
    if (!available) return;
    try {
      window.cioanalytics.page();
      if (debug) {
        console.debug('[CIO page change]');
      }
    } catch (error) {
      console.debug('[CIO page change: handled]', error);
    }
  };

  return {
    cioIdentify,
    cioReset,
    cioTrackEvent,
    cioTrackPageChange
  };
};

export const { cioIdentify, cioReset, cioTrackEvent, cioTrackPageChange } = cio({
  isEnabled: true
});
